import {Routes} from '@angular/router';
import { InvestigatorMicrobiologyComponent } from '../../investigator/microbiology/investigator-microbiology.component';
import { PageTitle } from '../../core/page-title';
import { navigationActivity } from '../../activities/navigation-activity/navigation-activity-resolver';
import { investigatorDefaultActivityHandler } from '../../activities/navigation-activity/handlers/investigator/investigator-default-activity-handler';

export const microbiologyDataRoutes: Routes = [
    {
        path: 'microbiology-data',
        pathMatch: 'full',
        redirectTo: 'microbiology-data/isolate-culture-data'
    },
    {
        path: 'microbiology-data/isolate-culture-data',
        data: {
            title: PageTitle.getInvestigatorTitle('Microbiology'),
            ...investigatorDefaultActivityHandler('View Microbiology Data')
        },
        resolve: { ...navigationActivity },
        component: InvestigatorMicrobiologyComponent
    }
];